module.exports = __webpack_public_path__ + "img/HongChi_logo_website.c7d81278.png";